import type { ReactElement } from 'react';
import { HomePage } from './HomePage';

/**
 * Componente raiz da aplicação.
 *
 * Renderiza a `HomePage` diretamente — a inicialização real (autenticação
 * por PIN e, só depois, o carregamento autenticado da configuração do
 * evento) acontece dentro do fluxo de ativação (`ActivationFlow`), nunca
 * antes do PIN ser validado (HUB-235, CA-01). Antes desta correção, o app
 * buscava `/config/event.json` (estático) incondicionalmente neste
 * componente, antes mesmo de exibir a tela de PIN.
 */
export function App(): ReactElement {
  return <HomePage />;
}
